<div class="np-time-picker">
  <label class="np-label" *ngIf="label">{{ label }}<span class="req" *ngIf="required"> *</span></label>

  <div class="np-trigger" [class.open]="open" [class.disabled]="disabled" (click)="toggle()">
    <span class="np-trigger-text" [class.placeholder]="!hasValue">
      {{ hasValue ? displayValue : '--:-- --' }}
    </span>
    <span class="np-trigger-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
        <path d="M12 7v5l3 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </span>
  </div>

  <div class="np-panel" *ngIf="open" (click)="$event.stopPropagation()">

    <div class="np-panel-header">
      <div class="np-time-display">
        <span class="np-hm clickable" [class.active]="mode==='hours'" (click)="mode='hours'">
          {{ hours | number:'2.0-0' }}
        </span>
        <span class="np-sep">:</span>
        <span class="np-hm clickable" [class.active]="mode==='minutes'" (click)="mode='minutes'">
          {{ minutes | number:'2.0-0' }}
        </span>
      </div>
      <div class="np-ampm">
        <button class="np-ampm-btn" [class.active]="period==='AM'" (click)="togglePeriod('AM')">AM</button>
        <button class="np-ampm-btn" [class.active]="period==='PM'" (click)="togglePeriod('PM')">PM</button>
      </div>
    </div>

    <div class="np-clock-wrap">
      <svg class="np-clock" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
        <circle cx="96" cy="96" r="90" fill="#faf8f5" stroke="#ede6dc" stroke-width="1.5"/>

        <line [attr.x1]="96" [attr.y1]="96"
              [attr.x2]="tipX" [attr.y2]="tipY"
              stroke="#8b1a1a" stroke-width="2.5" stroke-linecap="round"/>

        <circle cx="96" cy="96" r="4" fill="#8b1a1a"/>

        <circle [attr.cx]="tipX" [attr.cy]="tipY" r="14" fill="#8b1a1a" fill-opacity="0.15"/>
        <circle [attr.cx]="tipX" [attr.cy]="tipY" r="6" fill="#8b1a1a"/>

        <ng-container *ngFor="let n of clockNumbers">
          <circle [attr.cx]="n.x" [attr.cy]="n.y" r="13"
                  [attr.fill]="isActive(n) ? '#8b1a1a' : 'transparent'"
                  class="np-num-bg"
                  (click)="mode==='hours' ? selectHour(n.value) : selectMinute(n.value)"/>
          <text [attr.x]="n.x" [attr.y]="n.y + 4.5"
                text-anchor="middle"
                [attr.fill]="isActive(n) ? '#fff' : '#1c0e0e'"
                font-size="11" font-family="Plus Jakarta Sans, sans-serif" font-weight="600"
                class="np-num-text"
                (click)="mode==='hours' ? selectHour(n.value) : selectMinute(n.value)">
            {{ n.label }}
          </text>
        </ng-container>
      </svg>
    </div>

    <div class="np-mode-label">Select {{ mode === 'hours' ? 'hour' : 'minute' }}</div>

    <div class="np-panel-footer">
      <button class="np-cancel" (click)="close()">Cancel</button>
      <button class="np-ok" (click)="emit(); close()">OK</button>
    </div>
  </div>
</div>
